module.exports = __webpack_public_path__ + "media/images/icon-attach-c594f5cefa576d4bda888a269361515f.svg";